import React from 'react';
import styled from 'styled-components';

import { useSelector } from 'react-redux';
export default function SurveyStart({onComplete}) {
  const userInfo = useSelector((state) => {
    return state.userInfo;
  });
  let handleNext = (e) => {
    if(onComplete)
    {
      onComplete();
    }
  }
  return (
    <SurveyWrapper>
      <HeaderWrapper>😊</HeaderWrapper>
      <BodyWrapper>
          <StartTxt>
          {userInfo['name']}님에게 꼭 맞는 친구를<br />
          추천해 주기 위해<br />
          몇가지 물어볼게 있어요!
          </StartTxt>
          <CompleteBtn onClick={handleNext}>
          다음
          </CompleteBtn>
      </BodyWrapper>
    </SurveyWrapper>
  );
}
const SurveyWrapper = styled.div`
  padding : calc(100vw * (17.5 / 375)) calc(100vw * (16 / 375)) 0 ;
`;
const HeaderWrapper = styled.div`
  font-weight: bold;
  font-size: calc(100vw * (40 / 375));
  line-height: calc(100vw * (58 / 375));
  margin-bottom : calc(100vw * (16 / 375));
`;
const BodyWrapper = styled.div`
`
const StartTxt = styled.p`
  font-weight: bold;
  font-size: calc(100vw * (20 / 375));
  line-height: calc(100vw * (29 / 375));
  color: #121212;
`
const CompleteBtn = styled.div`
  position: fixed;
  width: 100%;
  height: calc(100vw * (72 / 375));
  bottom: 0;
  background: #FFCF19;
  z-index: 300;
  left: 0;
  line-height: calc(100vw * (72 / 375));
  text-align: center;
  font-weight: bold;
  font-size: calc(100vw * (18 / 375));
  z-index: 500;
`;